import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import styles from "./ManageOrders.module.scss";
import ManageOrderFilterTabs from "../../../../components/WholesalerComponents/ManageOrderFilterTabs/ManageOrderFilterTabs";
import PendingOrders from "../../../../components/WholesalerComponents/ManageOrderFilterTabs/PendingOrders/PendingOrders";
import AllOrders from "../../../../components/WholesalerComponents/ManageOrderFilterTabs/AllOrders/AllOrders";
import ReadyToShip from "../../../../components/WholesalerComponents/ManageOrderFilterTabs/ReadyToShip/ReadyToShip";
import Shipped from "../../../../components/WholesalerComponents/ManageOrderFilterTabs/Shipped/Shipped";
import Delivered from "../../../../components/WholesalerComponents/ManageOrderFilterTabs/Delivered/Delivered";
import Cancelled from "../../../../components/WholesalerComponents/ManageOrderFilterTabs/Cancelled/Cancelled";
import Returned from "../../../../components/WholesalerComponents/ManageOrderFilterTabs/Returned/Returned";
import RefundOnly from "../../../../components/WholesalerComponents/ManageOrderFilterTabs/RefundOnly/RefundOnly";
import FailedDelivery from "../../../../components/WholesalerComponents/ManageOrderFilterTabs/FailedDelivery/FailedDelivery";

const ManageOrders = () => {
    const [activeTab, setActiveTab] = useState("all");

    const renderTable = () => {
        switch (activeTab) {
            case "all":
                return <AllOrders />;
            case "pending":
                return <PendingOrders />;
            case "readyToShip":
                return <ReadyToShip />;
            case "shipped":
                return <Shipped />;
            case "delivered":
                return <Delivered />;
            case "cancelled":
                return <Cancelled />;
            case "returned":
                return <Returned />;
            case "refundOnly":
                return <RefundOnly />;
            case "failedDelivery":
                return <FailedDelivery />;
            default:
                return <>all Products</>;
        }
    };

    return (
        <div className={styles.container}>
            <h4 className={styles.heading}>Manage Orders</h4>

            <Container fluid className={styles.manageSection}>
                <Row className="g-0">
                    <Col xs="12">
                        <ManageOrderFilterTabs
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                    </Col>
                </Row>

                <Row className="g-0">
                    <Col>{renderTable()}</Col>
                </Row>
            </Container>
        </div>
    );
};

export default ManageOrders;